import type { GooglePlacesType } from "@/modules/google/types"

import { createContext, useContext } from "react"

const GooglePlacesContext = createContext<GooglePlacesType>(null)

const useGooglePlaces = (): GooglePlacesType => useContext(GooglePlacesContext)

export { GooglePlacesContext, useGooglePlaces }
